import React, { useEffect, useState } from 'react';
import ModalTemplateB from '../../../components/_template/modal/ModalTemplateB';
import './EnterPinCodeModal.scss';
import smallLogo from '../../../assets/images/logo_small.png';
import deleteImg from '../../../assets/images/img_delete.png';
import { ConnectedWallet } from '../../../assets/constant/kit.type';

const generateRandomPad = () => {
  const numArray = [...Array(10).keys(), -1, -1]; // [0, 1, 2, ..., 9, -1, -1]
  for (let i = numArray.length - 1; i > 0; i--) {
    const randomIndex = Math.floor(Math.random() * (i + 1));
    [numArray[i], numArray[randomIndex]] = [numArray[randomIndex], numArray[i]];
  }
  return numArray;
};

type EnterPinCodeModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  connectedWallet: ConnectedWallet;
  pin: string;
  setPin: (pin: string) => void;
  title?: string;
};
const EnterPinCodeModal = (props: EnterPinCodeModalProps) => {
  const { isOpen, closeModal, connectedWallet, pin, setPin, title } = props;
  const [randomNumbers, setRandomNumbers] = useState<number[]>([]);
  useEffect(() => {
    if (isOpen) {
      setPin('');
    }
    setRandomNumbers(generateRandomPad());
  }, [isOpen]);
  useEffect(() => {
    if (pin.length === 6) {
      closeModal();
    }
  }, [pin]);
  return (
    <ModalTemplateB isOpen={isOpen} title={title ? title : 'Enter Pin Code'} showDivideLine={false} onRequestClose={closeModal}>
      <div id="EnterPinCodeModal">
        <div>
          <div className="kit-label-value-wrapper" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div className="kit-label">Account Name</div>
            <div className="kit-value" style={{ justifyContent: 'flex-end' }}>
              {!connectedWallet.accountName ? '-' : connectedWallet.accountName}
            </div>
          </div>
          {/*<LabelValue label={'Account Address'} value={connectedWallet.connectAddress} />*/}
          <div className="kit-label-value-wrapper" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div className="kit-label">Account Address</div>
            <div className="kit-value">
              {!connectedWallet.connectAddress ? '-' : `${connectedWallet?.connectAddress.slice(0, 6)}...${connectedWallet?.connectAddress.slice(-5)}`}
            </div>
          </div>
        </div>
        <div className="pin-code-circle-wrapper">
          {Array.from({ length: 6 }, (_, i) => i).map((index) => (
            <div className={`pin-code-circle${pin.length > index ? ' active' : ''}`} key={index} />
          ))}
        </div>
        <div className="pin-code-button-wrapper">
          {randomNumbers.map((num, index) => (
            <button key={index} className={`pin-code-button${num === -1 ? ' logo' : ''}`} onClick={() => setPin(pin + num)} disabled={num === -1}>
              {num === -1 ? <img src={smallLogo} alt={'EQ'} /> : num}
            </button>
          ))}
          <button className={`pin-code-button clear`} onClick={() => setPin('')}>
            All Clear
          </button>
          <button className={`pin-code-button delete`} onClick={() => setPin('')}>
            <img src={deleteImg} alt={'Delete'} />
          </button>
        </div>
      </div>
    </ModalTemplateB>
  );
};

export default EnterPinCodeModal;
